














import Vue, { PropType } from 'vue';
import { IContract } from '@/models';

export default Vue.extend({
  name: 'ContractPhaseDisplay',

  props: {
    contract: { type: Object as PropType<IContract>, required: true }
  },

  computed: {
    getPhaseColor(): string {
      return this.contract.getPhaseColor();
    },

    getPhaseMessage(): string {
      return this.contract.getPhaseMessage();
    }
  }
});
